import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

import * as styles from "../components/styles/landing03.scss"

const EmbedsLanding = props => {
  return (
    <Layout location={props.location} title="Kommune" locale="da-dk">
      <Seo
        title="En dansk løsning, der binder patient og sundhedsvæsen sammen"
        lang="da-DK"
        pathname="en-dansk-losning-der-binder-patient-og-sundhedsvaesen-sammen"
      />
      <div className="content-wide landing2025">
        <div className="wide-container">
          <div className="wide-inner grid gap">
            <div className="landing-hero">
              <div className="landing-hero-left">
                <div className="landing-hero-pre">
                  Digital patientstøtte, der gør reform til praksis - i Danmark
                  og Europa.
                </div>
                <h1>
                  En <span className="fg-blue">dansk</span> løsning, der binder{" "}
                  <span className="fg-purple">patient</span> og{" "}
                  <span className="fg-purple">system</span> sammen
                </h1>
                <p>
                  Forløbsguiden fra Emento er en dansk løsning, der samler hele
                  patientens forløb ét sted og automatisk guider patienten
                  dag-for-dag med instrukser, direkte kontakt og påmindelser - i
                  takt med forløbets udvikling. Det betyder, at patienten ikke
                  overlades til sig selv mellem møder med systemet - men støttes
                  aktivt og målrettet med den rette information på det rette
                  tidspunkt.
                </p>
                <h3>
                  Det gør løsningen til et styringsredskab, ikke bare en
                  informationsbank
                </h3>
                <p>
                  Patienten får en oplevelse af “at have hospitalet i lommen”.
                  Resultatet er mere tryghed, bedre egenmestring, mindre spild
                  og øget kapacitet.
                </p>
                <p>
                  Løsningen er i drift i Danmark og 39 hospitaler og klinikker i
                  Tyskland, Østrig og Schweiz - og dokumenterer både europæisk
                  relevans og patientnær effekt uden merbelastning af klinikken.
                  Løsningen er uafhængig af globale platforme.
                </p>
                <div className="landing-hero-cta">
                  <a
                    href="/pdf/briefs/bind_patient_og_sundhedsvaesen_sammen.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button"
                  >
                    Download 2-siders brief
                  </a>
                  <a href="mailto:allan@emento.dk" className="button">
                    Book en kort præsentation
                  </a>
                </div>
              </div>
              <div className="landing-hero-right">
                <img
                  src="https://images.ctfassets.net/8eaotls8wqkz/1HDu7fQULHqIuwdbMhGEWl/2ccc1ebf94fd2871a2c1e50172fcc87b/ementostock_man_on_bench_with_dog.jpg?w=2048&h=1365&q=50&fm=webp"
                  alt="Lige adgang. Kortere forløb. Større tryghed."
                />
              </div>
            </div>
            <div className="landing-section">
              <div className="landing-section-left">
                <h2>
                  <span className="fg-blue">Nærsundhed</span> og digital kontakt
                  kræver mere end{" "}
                  <span className="fg-purple">strukturændringer</span>
                </h2>
                <p>
                  Reformer og regionssammenlægninger skal sikre nærsundhed,
                  digital kontakt og geografisk lighed. Men struktur skaber ikke
                  i sig selv sammenhæng for borgeren. Det kræver, at
                  veldokumenterede løsninger faktisk bliver udbredt og taget i
                  brug - på tværs af regioner og sektorer.
                </p>
                <p>
                  I dag sker det sjældent. Teknologier, der virker i lokal
                  drift, forbliver lokale, og det koster både effektivitet og
                  kontinuitet. Dertil, i modsætning til løsninger, der kun
                  formidler information, samler Forløbsguiden hele patientens
                  forløb ét sted. Dét skaber réel sammenhæng for borgeren og
                  frigør ressourcer i praksis.
                </p>
                <p>
                  Forløbsguiden er et eksempel på en løsning, der allerede
                  skaber værdi i praksis – og med sin dokumenterede effekt kan
                  imødekomme den europæiske opfordring om at opskalere egne
                  velfærdsteknologier og styrke konkurrenceevnen.
                </p>
              </div>
            </div>
            <div className="landing-section">
              <div className="landing-section-left">
                <h2>
                  Teknologi, der virker lokalt,{" "}
                  <span className="fg-purple">skaleres ikke</span> nationalt
                </h2>

                <div className="landing-section-bullet-boxes">
                  <div className="landing-section-bullet-box bg-light-pink">
                    <div className="landing-section-bullet-box-icon">
                      <img src="/svg/icons/emento_smiley_sad.svg" alt="" />
                    </div>
                    <p>Fragmenteret kommunikation og uensartet kvalitet</p>
                  </div>
                  <div className="landing-section-bullet-box bg-light-pink">
                    <div className="landing-section-bullet-box-icon">
                      <img src="/svg/icons/emento_smiley_sad.svg" alt="" />
                    </div>
                    <p>
                      Afdelinger opfinder egne løsninger uden skaleringsplan
                    </p>
                  </div>
                  <div className="landing-section-bullet-box bg-light-pink">
                    <div className="landing-section-bullet-box-icon">
                      <img src="/svg/icons/emento_smiley_sad.svg" alt="" />
                    </div>
                    <p>Effektivitet og patientsikkerhed tabes i overgange</p>
                  </div>
                  <div className="landing-section-bullet-box bg-light-pink">
                    <div className="landing-section-bullet-box-icon">
                      <img src="/svg/icons/emento_smiley_sad.svg" alt="" />
                    </div>
                    <p>
                      Europa efterlyser egne velfærdsteknologiske løsninger (jf.
                      Draghi-rapporten)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="landing-section">
              <h1>
                Forløbsguiden: Digital støtte, der{" "}
                <span className="fg-purple">samler trådene</span> - modsat andre
                systemer
              </h1>
              <ul className="landing-bullets bg-light-pink">
                <li className="bullet">
                  Samler instrukser, aftaler og direkte kontakt ét sted
                </li>
                <li className="bullet">
                  Guider patienten igennem forløbet - den rette information på
                  det rette sted
                </li>
                <li className="bullet">
                  Målretter støtte til dem med størst behov
                </li>
                <li className="bullet">
                  Mindsker behov for opkald, genindlæggelse og kontrolbesøg
                </li>
              </ul>
            </div>
            <div className="landing-section">
              <div className="landing-section-left">
                <h2>Udnyt det potentiale, der allerede findes</h2>
                <p>
                  Evalueringer i praksis viser markante effekter på drift og
                  tilfredshed:
                </p>
                <ul className="landing-bullets bg-light-pink">
                  <li className="bullet">
                    Op til <b>60%</b> kortere indlæggelsestid i kirurgiske
                    forløb
                  </li>
                  <li className="bullet">
                    <b>75%</b> adoption i relevante patientgrupper
                  </li>
                  <li className="bullet">
                    Op til <b>6.000 kr.</b> besparelse pr. patient
                  </li>
                  <li className="bullet">
                    Effektiviseringsgevinst <b>pr. afdeling</b>: op til{" "}
                    <b>400.000 kr.</b>
                    årligt
                  </li>
                  <li className="bullet">
                    Færre kontrolopkald og fejlkommunikation
                  </li>
                  <li className="bullet">
                    Øget patientsikkerhed og forudsigelige forløb
                  </li>
                </ul>
                <p>
                  Effekten er dokumenteret gennem evaluering i flere regioner,
                  herunder Slagelse Sygehus, hvor brugen af appen reducerede
                  meromkostninger ved forlænget indlæggelse med gennemsnitligt
                  5.993 kr. pr. patient.
                </p>
              </div>
            </div>
            <div className="landing-section">
              <h1>Giv mere til dem, der har mest brug for det</h1>
              <p>
                Forløbsguiden doserer information og kontakt løbende – i det
                format og tempo, der passer den enkeltes behov og forløb. Det
                gør differentieret støtte mulig uden øget belastning af
                personalet.
              </p>
            </div>
          </div>
        </div>

        <div className="space-8" />
        <div className="landing-statement bg-orange wide-container fg-white">
          <div className="landing-statement-image">
            <img
              src="/images/landing_pages/esundhed/statement-portrait-stinne.png"
              alt="Lige adgang. Kortere forløb. Større tryghed."
            />
          </div>
          <div className="landing-statement-text">
            <div className="landing-statement-quote">
              “Patienter føler sig egentligt hurtigere klar og trygge til at
              komme hjem, fordi de jo så ved, at de har informationen lige ved
              hånden. Det betyder, at vi kan få et lidt større flow af
              patienter.”
            </div>
            <div className="landing-statement-author">
              <div className="landing-statement-author-name">
                <span>
                  Stinne Koudahl, sygeplejerske, Mave-Tarmkirurgi, Aarhus
                  Universitetshospital
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-statement bg-light-purple wide-container fg-blue">
          <div className="landing-statement-text">
            <div className="landing-statement-quote">
              “Det var så trygt at bruge Forløbsguiden. Altså, det var som om,
              at jeg havde afdelingen i hånden. Det var en dejlig fornemmelse -
              som jeg ikke har prøvet før. En tryg fornemmelse.”
            </div>
            <div className="landing-statement-author">
              <div className="landing-statement-author-name">
                <span>
                  Ellen-Margrethe, patient, operationsforløb, Kvindesygdomme,
                  Aarhus Universitetshospital
                </span>
              </div>
            </div>
          </div>
          <div className="landing-statement-image">
            <img
              src="/images/landing_pages/esundhed/statement-portrait-ellen-margrethe.png"
              alt="Lige adgang. Kortere forløb. Større tryghed."
            />
          </div>
        </div>
        <div className="space-8" />
        <div className="wide-container">
          <div className="wide-inner">
            <div className="landing-hero">
              <div className="landing-hero-left">
                <h2>
                  Dansk velfærdsteknologi med europæisk rækkevidde og{" "}
                  <span className="fg-purple">dataetik</span> i front
                </h2>
                <p>
                  Forløbsguiden matcher målene i Life Science-strategien og
                  Draghi-rapportens opfordring til europæisk opskalering. Den er
                  klar til eksport og er allerede i drift i Tyskland, Schweiz og
                  Østrig.
                </p>
                <p>
                  Emento er vinder af{" "}
                  <a
                    href="https://finansforbundet.dk/dk/politik-og-analyser/dataetik/dataetikprisen-for-2023/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Dataetikprisen
                  </a>{" "}
                  og går længere end lovens krav for at beskytte borgerens
                  rettigheder og skabe tillid til teknologien. krav for at
                  beskytte borgerens rettigheder og skabe tillid til
                  teknologien.
                </p>
                <p>
                  Forløbsguiden er ikke kun en platform, der kan konfigureres
                  lokalt og bruges på tværs af sektorer og regioner. Det er et
                  eksempel på, hvordan Danmark kan forme fremtidens velfærd.
                </p>
                <p>
                  Forløbsguiden er uafhængig af globale platforme. Ingen data
                  opbevares eller behandles uden for EU.{" "}
                </p>
              </div>
              <div className="landing-map-right">
                <img
                  src="/images/landing_pages/emento_usage_map.png"
                  alt="Emento usage map"
                />
              </div>
            </div>
            <div className="landing-section">
              <h2>Vil I se, hvordan det virker i praksis?</h2>
              <p>
                Book en demo, et site-visit eller få tilsendt mere information.
              </p>
              <div className="landing-section-cta">
                <a
                  href="/pdf/briefs/bind_patient_og_sundhedsvaesen_sammen.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button"
                >
                  Download 2-siders brief
                </a>
                <a href="mailto:allan@emento.dk" className="button">
                  Book et møde
                </a>
                <a href="mailto:allan@emento.dk" className="button">
                  Kontakt os
                </a>
              </div>
            </div>
            <div className="space-8" />
            <p>relaterede nyheder:</p>
          </div>
        </div>
        <a
          href="https://emento.dk/blog/emento-vinder-dataetikprisen-2023/"
          className="landing-news-container"
        >
          <div className="landing-news">
            <div className="landing-news-left">
              <h2>Emento vinder Dataetikprisen 2023</h2>
              <a
                className="button"
                href="https://emento.dk/blog/emento-vinder-dataetikprisen-2023/"
              >
                Læs mere
              </a>
            </div>
            <div className="landing-news-right">
              <img
                src="https://images.ctfassets.net/8eaotls8wqkz/4w8U2xFVamnovMkx9JinYK/2d8eb540dd9b6e71bf0d1c91ea67c13a/IMG_7320.jpg?w=1920&h=1078&q=50&fm=webp"
                alt="Emento vinder Dataetikprisen 2023"
              />
            </div>
          </div>
        </a>
      </div>
    </Layout>
  )
}

export default EmbedsLanding
